import ScreenExchangeRateList from 'screens/ExchangeRate/List';
import ScreenExchangeRateDetails from 'screens/ExchangeRate/Details';
import ScreenExchangeRateCreate from 'screens/ExchangeRate/Create';
import ScreenExchangeRateUpdate from 'screens/ExchangeRate/Update';
import { EXCHANGE_RATE } from 'routes/paths';

const exchangeRatesRoutes = [
  {
    path: EXCHANGE_RATE.DETAILS,
    name: 'ExchangeRateDetails',
    component: ScreenExchangeRateDetails,
    allowPermissions: ['view_exchangerate'],
  },
  {
    path: EXCHANGE_RATE.CREATE,
    name: 'ExchangeRateCreate',
    component: ScreenExchangeRateCreate,
    allowPermissions: ['add_exchangerate'],
  },
  {
    path: EXCHANGE_RATE.UPDATE,
    name: 'ExchangeRateUpdate',
    component: ScreenExchangeRateUpdate,
    allowPermissions: ['change_exchangerate'],
  },
  {
    path: EXCHANGE_RATE.LIST,
    name: 'ExchangeRateList',
    component: ScreenExchangeRateList,
    allowPermissions: ['list_exchangerate'],
  },
];

export default exchangeRatesRoutes;
